export const invoicesState = {
  campground: {
    hasLateFeeConfig: false,
    isInventory: null,
    terminal: {
      configured: false,
      readerKey: null,
      testCardNumber: null,
      useMock: false,
      useSimulation: false,
    },
  },
  filters: {
    invoiceStatus: [],
    payoutStatus: '',
    term: '',
  },
  installmentDetails: {
    action: 'getDetails',
    changeOwed: '---',
    data: {},
    fetchDetails: false,
    error: null,
    loading: false,
  },
  installments: {
    data: {},
    error: null,
    loading: false,
  },
  isParamsReviewed: false,
  item: {},
  pagination: {
    currentPage: 1,
    perPage: 25,
  },
  sortedField: {},
}
